import React from "react";
import { useStore } from "../Store";
import { UnAuthorized } from "../Components/Result/UnAuthorized";
import { useMessageParentOrRedirect } from "../utils/useMessageParentOrRedirect";

export default function RequireAuth({ children }: { children: JSX.Element }) {
  const { access, data, isEmbedded, redirecting } = useStore();
  const { messageToParentUnauthorised } = useMessageParentOrRedirect();

  if (!access && !redirecting) {
    if (data?.session?.redirectUri != null) {
      let redirectUri = data?.session?.redirectUri;
      messageToParentUnauthorised({
        isEmbedded,
        redirectUri,
        consentId: data?.consent?.id,
        state: data?.session.state,
      });

      return null;
    } else {
      return <UnAuthorized />;
    }
  }

  return children;
}
